import { render, staticRenderFns } from "./CartVouchersComponent.vue?vue&type=template&id=b06f4ea6"
import script from "./CartVouchersComponent.vue?vue&type=script&lang=js"
export * from "./CartVouchersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports